import { FunctionComponent, ReactNode } from 'react';
import cn from 'classnames';
import styles from './AuthLayout.module.css';

interface IAuthLayoutProps {
    className?: string;
    children: ReactNode;
}

const AuthLayout: FunctionComponent<IAuthLayoutProps> = ({
    className,
    children,
}) => {
    return (
        <main className={cn(styles.authLayout, className)}>
            <div className={cn(styles.authLayoutIn)}>
                <div className={cn(styles.authLayoutMain)}>
                    <div className={cn(styles.authLayoutCard)}>
                        {children}
                    </div>
                </div>
                <div className={cn(styles.authLayoutFooter)}>
                    <div className={cn(styles.footerText)}>Copyright © {new Date().getFullYear()} Fishinity.com All rights reserved.</div>
                </div>
            </div>
        </main>
    );
};

export default AuthLayout;
